import EquipmentGroup from '../entities/EquipmentGroup'

const sortEquipmentGroupsByOrdering = (equipmentGroups: EquipmentGroup[], equipmentGroupsOrdering: string[] | null | undefined): EquipmentGroup[] => {
    if (!equipmentGroupsOrdering || equipmentGroupsOrdering.length === 0 || !equipmentGroups || equipmentGroups.length === 0) {
        return [...equipmentGroups]
    }
    // mapping each id from the ordering list to its index for fast lookup
    const orderMap = new Map(equipmentGroupsOrdering.map((id, index) => [id, index]))

    return [...equipmentGroups].sort((a, b) => {
        // get the order index for each group id
        const orderA = orderMap.get(a.id)
        const orderB = orderMap.get(b.id)

        // if both ids are found in the ordering it will be sorted by their index
        if (orderA !== undefined && orderB !== undefined) {
            return orderA - orderB
        }
        // case where one id is found, that one comes first
        if (orderA !== undefined) {
            return -1
        }
        if (orderB !== undefined) {
            return 1
        }
        // if none of the ids anre in the ordering, preserve original order
        return equipmentGroups.indexOf(a) - equipmentGroups.indexOf(b)
    })
}

export default sortEquipmentGroupsByOrdering
